// extracted by mini-css-extract-plugin
module.exports = {"scrollUpBtn":"ScrollUpBtn_scrollUpBtn__3iIvs","show":"ScrollUpBtn_show__21z-N"};